// Automatically generated from TW.Saga.Shared.MetadataLib, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 18:53:46
import { ListStatusCollection_abstract } from './../abstract/SagaStateLib/ListStatusCollection_abstract';
export class ListStatusCollection extends ListStatusCollection_abstract {}
